<template>
  <div>{{Espere}}</div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      Espere: "Espere un momento..."
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
     ...mapActions(["cargarData"]),
    ...mapActions("comun", ["loguear","traerUserId"]),
    async fetchData() {
      let q = this.$route.query;
      let data = {
        Token: q.t,
        Username: q.n
      };
      await this.loguear(data);
      this.cargarData();
      this.traerUserId();
      this.$router.push("/");
    }
  }
};
</script>
